import React from "react";

const AuthorBox = () => {
  return (
    <div className="author-box-wrap flex mx-4 md:mx-36 max-w-3xl mb-14 md:mb-16">
      <a href="/blog/author/expressvpn/" aria-label="author-photo">
        <noscript>
          <img
            alt=""
            src="https://upload.wikimedia.org/wikipedia/commons/b/b3/Eo_circle_purple_white_letter-n.svg"
            srcSet="https://s22908.pcdn.co/wp-content/uploads/2021/03/expressvpn-blog-1-150x150.png 2x"
            className="avatar avatar-96 photo"
            height="96"
            width="96"
            decoding="async"
          />
        </noscript>
        <img
          alt=""
          src="https://upload.wikimedia.org/wikipedia/commons/b/b3/Eo_circle_purple_white_letter-n.svg"
          data-src="https://s22908.pcdn.co/wp-content/uploads/2021/03/expressvpn-blog-1-150x150.png"
          data-srcset="https://s22908.pcdn.co/wp-content/uploads/2021/03/expressvpn-blog-1-150x150.png 2x"
          className="avatar avatar-96 photo lazyloaded"
          height="96"
          width="96"
          decoding="async"
        />
      </a>
      <div className="desc ml-4">
        <div className="td-author-name vcard author font-bold">
          <span className="fn">
            <a href="/blog/author/expressvpn/">PrepNexa Ai</a>
          </span>
        </div>
        <div className="td-author-description">
          PrepNexa is committed to your PTE success and excellence. Stay tuned
          for updates, expert advice, and the latest resources to elevate your
          PTE preparation journey.
        </div>
        <div className="td-author-social"></div>
      </div>
    </div>
  );
};

export default AuthorBox;
